'use strict';

const React = require('react');    // no, you can't remove this


const FooterBox = () => {
    return (
        <div className="cover-container">
            <div className="footer">
                <div className="inner-small">
                    <p>Copyright &copy; <a href="http://ag-projects.com" target="_blank" rel="noopener noreferrer">AG Projects</a></p>
                </div>
            </div>
        </div>
    );
};


module.exports = FooterBox;
